export const colors = {
  // Primary Colors
  "primary-100": "#0E0B19",
  "primary-90": "#44396C",
  "primary-80": "#4D4279",
  "primary-70": "#5D508A",
  "primary-60": "#615492",

  primary: "#7562A8",

  "primary-40": "#9182C6",
  "primary-30": "#BDB4DD",
  "primary-20": "#E9E6F4",
  "primary-10": "#FBFBFD",

  // Secondary Colors
  "secondary-lightest": "#E6F3F3",
  "secondary-lighter": "#B5DADB",
  "secondary-light": "#84C1C3",

  secondary: "#54A6AA",

  "secondary-dark": "#3B787B",
  "secondary-darker": "#24484A",
  "secondary-darkest": "#0C1819",

  // Tertiary Colors
  "tertiary-lightest": "#F2E8EF",
  "tertiary-lighter": "#D8B9CE",
  "tertiary-light": "#BE8AAD",

  tertiary: "#A86392",

  "tertiary-dark": "#754164",
  "tertiary-darker": "#46273C",
  "tertiary-darkest": "#170D14",

  // Success Colors
  "success-lightest": "#CFEEDE",
  "success-lighter": "#A1DEBC",
  "success-light": "#58C488",

  success: "#0AAB51",

  "success-dark": "#07773B",
  "success-darker": "#064522",
  "success-darkest": "#032210",

  // Warning Colors
  "warning-lightest": "#FFF2E6",
  "warning-lighter": "#FFE8D4",
  "warning-light": "#FFDDBF",

  warning: "#EB9144",

  "warning-dark": "#F1801F",
  "warning-darker": "#F3811F",
  "warning-darkest": "#DF7A23",

  // Error Colors
  "error-lightest": "#FAD1D9",
  "error-lighter": "#F4A1B3",
  "error-light": "#EB5A7B",

  error: "#E11D3F",

  "error-dark": "#9E112C",
  "error-darker": "#5A0719",
  "error-darkest": "#2E030B",

  // Caution Colors
  "caution-lightest": "#FEF2D7",
  "caution-lighter": "#FDE5AC",
  "caution-light": "#FBD06F",

  caution: "#FBBC21",

  "caution-dark": "#B38419",
  "caution-darker": "#654D0D",
  "caution-darkest": "#33250A",

  // Brown Colors
  "brown-lightest": "#FFF0DA",
  "brown-lighter": "#F8E3C3",
  "brown-light": "#F2D7AE",

  brown: "#BB6B26",

  "brown-dark": "#9A602B",
  "brown-darker": "#844D1B",
  "brown-darkest": "#835328",

  // Gray Colors
  "gray-10": "#FEFEFE",
  "gray-20": "#FAFAFA",
  "gray-30": "#F4F4F4",
  "gray-40": "#ECECEC",
  "gray-50": "#E6E6E6",
  "gray-60": "#D6D6D6",
  "gray-70": "#B5B5B6",
  "gray-80": "#939393",
  "gray-90": "#727272",
  "gray-100": "#666666",

  // Red Colors
  "red-dark": "#800F25",

  red: "#E698A7",

  "red-light": "#F3B6C2",
  "red-lightest": "#FFF6F8",

  black: "#212121",
  charcoal: "#4B4B4B",

  white: "#FFFFFF",

  // Nav bar
  "navbar-link-selected-underline": "$secondary-lighter",
  "navbar-link-hover-underline": "$secondary-lightest",
  "navbar-link-focus-selected-underline": "$secondary-lighter",
  "navbar-link-focus-border": "$primary-30",
  "navbar-search-bar-active-border": "$primary-40",
  "navbar-ward-select-option-selected-border": "$primary",
  "navbar-ward-select-option-selected-hover": "$primary",
  "navbar-ward-select-option-selected-text": "#48397D ",
  "navbar-ward-select-active-text": "#48397D",
  "navbar-ward-select-active-background": "$primary-20",
  "navbar-ward-select-active-icon": "#48397D",
  "navbar-ward-select-active-hover": "#eae6f4cc",
  "navbar-button-active-border": "$secondary-lightest",

  // Table
  "table-row-hover-background": "#E9E6F47A",
  "table-row-selected-background": "$secondary-lightest",
  "table-row-focus-background": "$secondary-lightest",
  "table-row-focus-border": "$primary-30",
  "table-row-messages-circle": "$secondary-dark ",
  "table-row-highlighted-background-primary": " #e6f3f3b3 ",
  "table-row-highlighted-background-secondary": " #e6f3f37a ",

  // Button colors
  "button-background": "$primary",
  "button-text": "$white",
  "button-border": "$primary",
  "button-hover-background": "$primary-60",
  "button-hover-border": "$primary-60",
  "button-focus-border": "$primary-30",
  "button-loading-background": "$primary-90",
  "button-loading-border": " $primary-90",
  "button-loading-hover-background": " $primary-90",
  "button-loading-hover-border": " $primary-90",
  "button-active-background": "$primary-90",
  "button-disabled-text": "$white",
  "portal-small-add-button-hover": "$primary",

  // Builder layout
  "builder-banner-background": "$primary-80",
  "builder-section-button-selected-underline": "$primary-30",
  "builder-section-button-hover-underline": "$primary-20",
  "builder-section-button-focus-underline": "$primary-20",
  "builder-button-primary-background": "$primary-40",
  "builder-button-primary-border": "$primary-40 ",
  "builder-button-primary-hover-background": "$primary-30 ",
  "builder-button-primary-focus-border": "$primary-30 ",
  "builder-button-primary-text": "$white ",
  "builder-button-secondary-background": "$white",
  "builder-button-secondary-border": "$white",
  "builder-button-secondary-text": "$primary-70",
  "builder-button-secondary-hover-background": "$gray-40",
  "builder-button-secondary-focus-border": "$primary-30",
  "builder-button-tertiary-background": "transparent",
  "builder-button-tertiary-text": "$white",
  "builder-button-tertiary-hover-background": "#FFFFFF26",
  "builder-button-tertiary-focus-border": "$white",
  "builder-protocol-action-container-active-bar": "$secondary",

  // modal
  "measurement-modal-filter-button-active-background": "$primary-20",
  "measurement-modal-filter-button-active-border": "$primary-30",
  "measurement-modal-filter-button-active-text": "#48397D",
  "measurement-modal-filter-button-active-hover-background": "#D0CAE7",
  "measurement-modal-baseline-save-button-text": "$primary-70",
  "measurement-modal-baseline-confirm-modal-cancel-button-hover": "$primary-40",
  "portal-modal-note-background": "#e9e6f499",
  "portal-modal-note-text": "$primary-70",

  // care info
  "care-info-add-link-button-color": "$primary",
  "care-info-add-link-button-hover-color": "$primary-70",

  // patient details
  "patient-details-edit-hover": "#e9e6f47a",
  "patient-details-edit-dropdown-hover": "$primary-30",

  // rich text editor
  "portal-rich-text-editor-toolbar-focus-icon": "$primary-40 ",
  "portal-rich-text-editor-toolbar-focus-border": "$primary-40  ",
  "portal-rich-text-editor-toolbar-active-icon": "$primary-40 ",
  "portal-rich-text-editor-toolbar-active-background": "$primary-20",

  // toggle
  "portal-toggle-checked-background": "$primary-30",
  "portal-toggle-checked-thumb-background": "$primary",
  "portal-toggle-checked-thumb-border": "$primary",

  // date picker
  "portal-date-picker-popup-today-cell-border": "$primary-30",
  "portal-date-picker-popup-time-cell-selected-background": "$primary-30",
  "portal-date-picker-popup-calendar-cell-selected-background": "$primary-20",
  "portal-date-picker-popup-ok-button-color": "$primary",
  "portal-date-picker-popup-ok-button-hover-color": "$primary-60",

  // time picker
  "portal-time-picker-hover-border": "$primary-30",
  "portal-time-picker-focus-border": "$primary-30",
  "portal-time-picker-popup-selected-cell": "$primary-20",

  // date range
  "portal-date-range-day-hover-border": "$secondary-light",
  "portal-date-range-day-today-text": "$secondary",
  "portal-date-range-day-selected-background": "$secondary",
  "portal-date-range-day-today-background": "$secondary-lightest",
  "portal-date-range-trail": "$secondary-lightest",

  // dropdown
  "portal-dropdown-popup-selected-background": "$primary-20",
  "portal-dropdown-popup-selected-icon": "$primary",
  "portal-dropdown-selected-border": "$primary-30",

  // text input
  "portal-text-input-border-hover": "$primary-30",
  "portal-text-input-border-focus": "$primary-30",

  // radio button
  "portal-radio-button-dot": "$primary",

  // loading spining state
  "portal-loading-state-color": "$primary",

  // surveys progress bar
  "surveys-progress-bar-stroke-color": "$primary-30",
  "surveys-progress-bar-trail-color": "$primary-20",

  // surveys progress bar
  "surveys-slider-trail": "$secondary-lighter",
  "surveys-slider-dot": "$primary-40",
};
